var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"visitors-donut"}},[_c('card',{attrs:{"icon":"chart-area","headline":_vm.$t('visitors.channels.headline'),"description":_vm.$t('visitors.channels.description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }